import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../../styles/Accordion.module.scss';
import { handleImpressionsTrack, sendOtp, updateEcs } from '../../../api';
import { useAuth } from '../../../contexts/auth';
import { handleResendTimer } from '../../../reducersAndActions/actions/authAction';
import { clickTracker } from '../../../lib/common';

export default function CampaignsType({
  campaigndetails,
  data,
  setData,
  setCurrentComponent,
  currentComponent,
  status,
  faqdetails,
  ecsdetails,
  getAllEcsDetails,
  reasoncancel,
  projectId,
  faqObj,
  // setIsUpdate,
}) {
  const [disable, setDisable] = useState(true);
  const [reactivateEcs, setReactivateEcs] = useState(false);
  const [authState, authDispatch] = useAuth();
  const { selectedBusiness } = authState;
  const [_campaigns, _setCampaigns] = useState({});
  const [checkboxes, setCheckboxes] = useState([]);
  const [labels, setlabels] = useState([]);
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));

  const handleChange = async (checked, item, campagins = '') => {
    const _data = _campaigns;
    if (campagins) _data[item] = checked;
    else _data[item.camp_id] = checked;
    _setCampaigns({ ..._data });
    setData({ ...data, campaigns: _data });
  };
  // const handleDuplicateCheck = (item) => {};
  useEffect(() => {
    setDisable(true);
    let _c = checkboxes;
    _c = [];
    let _l = labels;
    _l = [];
    setCheckboxes([..._c]);
    setlabels([..._l]);
    let _ca = _campaigns;
    _ca = {};
    _setCampaigns({ ..._ca });

    setData({ ...data, campaigns: {} });
    campaigndetails.map((item) => {
      if (status.toLowerCase() === 'stop' && item.camp_status === 'active') {
        const _data = _c;
        _data.push(item);
        setCheckboxes([..._data]);
      } else if (status.toLowerCase() === 'stop' && item.camp_status === 'stopped') {
        const _indata = _l;
        _indata.push(item);
        setlabels([..._indata]);
      } else if (status.toLowerCase() === 'reactivate' && item.camp_status === 'stopped') {
        const _data = _c;
        _data.push(item);
        setCheckboxes([..._data]);
      } else if (status.toLowerCase() === 'reactivate' && item.camp_status === 'active') {
        const _indata = _l;
        _indata.push(item);
        setlabels([..._indata]);
      }
      return '';
    });
  }, [status, faqdetails]);

  useEffect(() => {
    _setCampaigns(data.campaigns);
  }, []);
  useEffect(() => {
    let flag = 0;
    if (Object.keys(_campaigns).length > 0)
      Object.keys(_campaigns).map((item) => {
        if (_campaigns[item] === true) {
          flag = 1;
        }
        return '';
      });

    if (flag) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [_campaigns]);
  useEffect(() => {
    if (Object.keys(data.campaigns).length === 0) setDisable(true);
    if (reasoncancel) setDisable(false);
  }, [data.campaigns, reasoncancel]);

  const handleProceedBtn = async () => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_proceed`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_ecs`;
      const llTrdInside = `faq_${faqObj?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    setCurrentComponent(currentComponent + 1);
    setData({ ...data, campaigns: _campaigns });
    if (projectId === 'csportal') {
      if (status.toLowerCase() === 'reactivate') {
        await sendOtp();
        handleResendTimer(authDispatch, {
          ...authState,
          resendOtp: true,
        });
      }
    }
    await clickTracker(`FAQ_${status.toLowerCase()}_proceed1`, `ecs_FAQ_${status.toLowerCase()}`);
  };

  const ecsStatusesTextObj = {
    stop: {
      csportal: `Currently your ECS on all your service/s is stopped. If you wish to reactivate your ECS, please select "Reactivate my ECS"`,
      genio: `Currently ECS on all service/s is stopped. If you wish to reactivate ECS, please inform vendor to select "Reactivate my ECS" on CS portal on JD App`,
    },
    active: {
      csportal: `Currently your ECS on all your service/s is active. If you wish to stop your ECS, please select "stop my ECS"`,
      genio: `Currently ECS on all service/s is active. If you wish to stop ECS, please inform vendor to select "stop my ECS" on CS portal on JD App`,
    },
  };

  return (
    <div>
      {ecsdetails.activateECSatContractLevel ? (
        <div className={`${styles.Accordion__Contant__Btnbox}`}>
          {status.toLowerCase() === 'stop' ? (
            <div className="font12 fw400 color777">{ecsStatusesTextObj.stop[projectId]}</div>
          ) : (
            <button
              type="button"
              className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
              style={{
                backgroundColor: `#0076d7`,
                border: `1px solid #0076d7`,
                transitionProperty: 'background-color, background-image, border-color, box-shadow',
                transition: 'all 0.8s',
                color: `#fff`,
              }}
              onClick={async () => {
                const campnsIds = [];
                let amountsum = 0;
                campaigndetails.map((item) => {
                  if (item.camp_status.toLowerCase() === 'active') {
                    campnsIds.push(item.camp_id);
                    amountsum += item.camp_monthly_budget;
                  }
                  return '';
                });
                const req = {
                  pid:
                    projectId === 'csportal' ? selectedBusiness?.parentid || '' : selectedBusinessGenio?.parentId || '',
                  city: projectId === 'genio' ? selectedBusinessGenio?.city || '' : selectedBusiness?.data_city,
                  reason: 'reactivate ecs',
                  url: window.location.href, //  window location url
                  compname: '', // selected buisness
                  campaignId: campnsIds.join(), // for canceled case all campaigns will be selected
                  amount: amountsum, //  total selected campaigns total
                  action:
                    status.toLowerCase() === 'stop' || status.toLowerCase() === 'cancel' ? 'deactivate' : 'activate', // for pause activate and for reactivate/canceled  deactivate
                };
                await clickTracker(`FAQ_${status.toLowerCase()}_reactivate`, `ecs_FAQ_reactivate`);
                await updateEcs({ ...req });
                setReactivateEcs(true);
                await getAllEcsDetails();
                setCurrentComponent(3);
                // window.location.reload();
              }}
            >
              {projectId === 'csportal' ? 'Reactivate my ECS' : 'Reactivate ECS'}
            </button>
          )}
        </div>
      ) : (
        <>
          {checkboxes && checkboxes.length > 0 && labels.length > 0 && (
            <div className="font12 fw700 color111 mt-2">
              {status.toLowerCase() === 'stop'
                ? `You have the following services stop`
                : `You have the following services active `}
            </div>
          )}
          {checkboxes && checkboxes.length > 0 ? (
            <ul>
              {labels.map((item) => {
                return <li style={{ fontSize: '15px' }}>{item.camp_name}</li>;
              })}
            </ul>
          ) : (
            <div className="font12 fw400 color777">
              {!reactivateEcs && status.toLowerCase() === 'stop'
                ? ecsStatusesTextObj.stop[projectId]
                : !reactivateEcs && ecsStatusesTextObj.active[projectId]}
            </div>
          )}
          {checkboxes && checkboxes.length > 0 && (
            <div className="font12 fw700 color111 mb-12">
              {checkboxes.length === 1
                ? `Please select proceed if you wish to ${status} ECS for this service`
                : `Please select the services for which you wish to ${status} your ECS.`}
            </div>
          )}

          <ul className={`${styles.Accordion__Items}`}>
            {checkboxes.map((item, idx) => {
              return (
                <>
                  <li className={`${styles.Accordion__Item}`}>
                    <label
                      htmlFor={`ecs_campaign_type_checkbox_id_${idx}`}
                      className={` ${styles.Accordion__Radio__Lable}`}
                    >
                      <input
                        id={`ecs_campaign_type_checkbox_id_${idx}`}
                        className={`${styles.Accordion__Radio__Input} `}
                        type="checkbox"
                        name="sidcity_radio"
                        onChange={async (e) => {
                          const { checked } = e.target;
                          handleChange(checked, item);
                          if (checked) {
                            await clickTracker(
                              `FAQ_${status.toLowerCase()}_${item?.camp_name}`,
                              `ecs_FAQ_${status.toLowerCase()}`,
                            );
                          }
                        }}
                        defaultChecked={data.campaigns[item.camp_id]}
                        defaultValue={data.campaigns[item.camp_id]}
                      />
                      <span className={`${styles.Accordion__Radio__Icon} csicon `} />
                      <span className={` ${styles.Accordion__Radio__Text} font14 fw400 color111`}>
                        {item.camp_name}{' '}
                      </span>
                    </label>
                  </li>
                </>
              );
            })}
          </ul>
          {campaigndetails && campaigndetails.length > 5 && (
            <a className={`${styles.Helpful__Left}`}>
              <div className={`${styles.Helpful__LeftAnchor}`}>
                <span className="font11 fw500 color007 pr-4">View More</span>
                <span className={`${styles.LeftAnchor__Icon} csicon`} />
              </div>
            </a>
          )}
          {checkboxes && checkboxes.length > 0 && (
            <div className={`${styles.Accordion__Contant__Btnbox}`}>
              <button
                type="button"
                className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
                style={{
                  backgroundColor: `${!disable ? '#0076d7' : '#CCCCCC'}`,
                  border: `1px solid ${disable ? '#E0E0E0' : '#CCCCCC'}`,
                  transitionProperty: 'background-color, background-image, border-color, box-shadow',
                  transition: 'all 0.8s',
                  color: `#FFFFFF`,
                }}
                disabled={disable}
                onClick={() => handleProceedBtn()}
              >
                Proceed
              </button>
            </div>
          )}
        </>
      )}

      {/* <Reasons /> */}
    </div>
  );
}

CampaignsType.propTypes = {
  campaigndetails: PropTypes.array,
  data: PropTypes.object,
  setData: PropTypes.func,
  setCurrentComponent: PropTypes.func,
  currentComponent: PropTypes.number,
  status: PropTypes.string,
  faqdetails: PropTypes.func,
  activateECSatContractLevel: PropTypes.bool,
  ecsdetails: PropTypes.object,
  getAllEcsDetails: PropTypes.func,
  reasoncancel: PropTypes.bool,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
};
